/* ============================================
   KALLOS QUIZ — Motor de Recomendación
   All Beauty Chile
   ============================================ */

(function () {
  'use strict';

  /* ------------------------------------------
     PRODUCT DATABASE
     ------------------------------------------
     Cada producto tiene:
     - id: código del listado
     - name: nombre comercial en español
     - line: línea a la que pertenece
     - type: shampoo | mask | styling | treatment
     - size: tamaño
     - price: precio en CLP (sin formato)
     - image: URL de imagen (completar con URLs de Shopify)
     - url: URL del producto en la tienda (completar con handles de Shopify)
  ------------------------------------------ */

  const PRODUCTS = {
    // === SHAMPOOS ===
    color_shampoo:       { id: 'KJMN0842', name: 'Color Shampoo con Aceite de Linaza y Filtro UV', line: 'color', type: 'shampoo', size: '1000ml', price: 11900, variantId: 46855469301909, image: 'https://cdn.shopify.com/s/files/1/0763/6025/3589/files/892.jpg?v=1768684289', url: '/products/kallos-shampoo-color-1000ml-proteccion-y-brillo-para-cabello-tenido' },
    algae_shampoo:       { id: 'KJMN1131', name: 'Algae Shampoo con Extracto de Algas y Aceite de Oliva', line: 'algae', type: 'shampoo', size: '1000ml', price: 11900, variantId: 46855469498517, image: 'https://cdn.shopify.com/s/files/1/0763/6025/3589/files/889.jpg?v=1768684296', url: '/products/kallos-shampoo-algae-1000ml-hidratacion-profunda-minerales-y-fortalecimiento-capilar' },
    banana_shampoo:      { id: 'KJMN1130', name: 'Banana Shampoo con Complejo Multivitamínico', line: 'banana', type: 'shampoo', size: '1000ml', price: 11900, variantId: 46855469564053, image: 'https://cdn.shopify.com/s/files/1/0763/6025/3589/files/891.jpg?v=1768684298', url: '/products/kallos-shampoo-banana-1000ml-hidratacion-profunda-y-suavidad' },
    coconut_shampoo:     { id: 'KJMN1609', name: 'Coconut Shampoo Nutritivo Fortalecedor', line: 'coconut', type: 'shampoo', size: '1000ml', price: 11900, variantId: 46855469269141, image: 'https://cdn.shopify.com/s/files/1/0763/6025/3589/files/883.jpg?v=1768684288', url: '/products/kallos-shampoo-coconut-1000ml-nutricion-y-brillo' },
    biotin_shampoo:      { id: 'KJMN1410', name: 'Biotin Beautifying Shampoo', line: 'biotin', type: 'shampoo', size: '1000ml', price: 11900, variantId: 46855469203605, image: 'https://cdn.shopify.com/s/files/1/0763/6025/3589/files/882.jpg?v=1768684286', url: '/products/kallos-shampoo-biotin-1000ml-fortalecedor-volumen-y-anti-caida-profesional' },
    blueberry_shampoo:   { id: 'KJMN1156', name: 'Blueberry Revitalizing Shampoo', line: 'blueberry', type: 'shampoo', size: '1000ml', price: 11900, variantId: 46855469400213, image: 'https://cdn.shopify.com/s/files/1/0763/6025/3589/files/887.jpg?v=1768684293', url: '/products/kallos-shampoo-blueberry-1000ml-antioxidante-brillo-intenso-y-proteccion-capilar' },
    multivitamin_shampoo:{ id: 'KJMN1207', name: 'Multivitamin Shampoo', line: 'multivitamin', type: 'shampoo', size: '1000ml', price: 11900, variantId: 46855469334677, image: 'https://cdn.shopify.com/s/files/1/0763/6025/3589/files/884.jpg?v=1768684290', url: '/products/kallos-shampoo-multivitamin-1000ml-nutricion-esencial-y-revitalizacion-capilar' },
    caviar_shampoo:      { id: 'KJMN1242', name: 'Caviar Restorative Shampoo', line: 'caviar', type: 'shampoo', size: '1000ml', price: 11900, variantId: 46855469465749, image: 'https://cdn.shopify.com/s/files/1/0763/6025/3589/files/888.jpg?v=1768684294', url: '/products/kallos-shampoo-caviar-1000ml-regeneracion-anti-edad-y-fuerza-para-tu-cabello' },
    cherry_shampoo:      { id: 'KJMN1157', name: 'Cherry Shampoo', line: 'cherry', type: 'shampoo', size: '1000ml', price: 11900, variantId: 46855469531285, image: 'https://cdn.shopify.com/s/files/1/0763/6025/3589/files/890.jpg?v=1768684297', url: '/products/kallos-shampoo-cherry-1000ml-brillo-y-vitalidad' },
    keratin_shampoo:     { id: 'KJMN0843', name: 'Keratin Shampoo con Keratina y Proteína de Leche', line: 'keratin', type: 'shampoo', size: '1000ml', price: 11900, variantId: 46855469367445, image: 'https://cdn.shopify.com/s/files/1/0763/6025/3589/files/886.jpg?v=1768684291', url: '/products/kallos-shampoo-keratin-1000ml-reparacion-intensa-suavidad-y-efecto-anti-frizz' },
    mango_shampoo:       { id: 'KJMN1543', name: 'Mango Moisture Repair Shampoo', line: 'mango', type: 'shampoo', size: '1000ml', price: 11900, variantId: 46855469138069, image: 'https://cdn.shopify.com/s/files/1/0763/6025/3589/files/879.jpg?v=1768684285', url: '/products/kallos-shampoo-mango-1000ml-limpieza-hidratante-y-vitalidad-tropical-profesional' },
    aloe_shampoo:        { id: 'KJMN1189', name: 'Aloe Moisture Repair Shine Shampoo', line: 'aloe', type: 'shampoo', size: '1000ml', price: 11900, variantId: 46855469170837, image: 'https://cdn.shopify.com/s/files/1/0763/6025/3589/files/880.jpg?v=1768684286', url: '/products/kallos-shampoo-aloe-1000ml-hidratacion-profunda' },
    argan_shampoo:       { id: 'KJMN1871', name: 'Argán Hair Shampoo', line: 'argan', type: 'shampoo', size: '1000ml', price: 11900, variantId: 46855464943765, image: 'https://cdn.shopify.com/s/files/1/0763/6025/3589/files/2530.jpg?v=1768684190', url: '/products/kallos-shampoo-argan-1000ml' },
    rosemary_shampoo:    { id: 'KJMN2222', name: 'Rosemary Shampoo', line: 'rosemary', type: 'shampoo', size: '1000ml', price: 11900, variantId: 46855465992341, image: 'https://cdn.shopify.com/s/files/1/0763/6025/3589/files/2598.jpg?v=1768684214', url: '/products/kallos-shampoo-de-romero-estimulante-del-crecimiento-anticaida-y-limpieza-profunda-1000ml' },
    deep_cleansing_shampoo: { id: 'KJMN0794', name: 'Deep Cleansing Shampoo', line: 'deep_cleansing', type: 'shampoo', size: '1000ml', price: 19900, variantId: 46855469924501, image: 'https://cdn.shopify.com/s/files/1/0763/6025/3589/files/Disenosintitulo-2026-02-25T153440.709.png?v=1772044503', url: '/products/kallos-champu-limpieza-profunda-1000ml-clarificante-profesional-antiresiduos' },
    silver_shampoo:      { id: 'K0213', name: 'Silver Coloring Shampoo', line: 'silver', type: 'shampoo', size: '350ml', price: 8900, variantId: 47005751246997, image: 'https://cdn.shopify.com/s/files/1/0763/6025/3589/files/Disenosintitulo-2026-02-25T150818.725.png?v=1772042906', url: '/products/kallos-silver-shampoo-colorante-reflex-matizador-violeta-para-cabello-rubio-y-canoso' },
    protox_shampoo:      { id: 'KJMN1149', name: 'Hair Pro-Tox Shampoo con Keratina, Colágeno y Ác. Hialurónico', line: 'protox', type: 'shampoo', size: '500ml', price: 12900, variantId: 47127291232405, image: 'https://cdn.shopify.com/s/files/1/0763/6025/3589/files/Disenosintitulo-2026-03-18T120634.226.png?v=1773846422', url: '/products/kallos-shampoo-pro-tox-limpieza-suave-fortalecimiento-y-volumen-500ml-1000ml' },
    protox_super_shampoo:{ id: 'SUP1772', name: 'Pro-Tox Superfruits Shampoo', line: 'protox_super', type: 'shampoo', size: '500ml', price: 12900, variantId: 46950730170517, image: 'https://cdn.shopify.com/s/files/1/0763/6025/3589/files/Diseno_sin_titulo_-_2026-02-24T174340.888.png?v=1771965848', url: '/products/kallos-champu-hair-pro-tox-superfruits-desintoxicacion-y-fortalecimiento-500ml-1000ml' },
    plex_shampoo:        { id: 'K1821', name: 'Plex Bond Builder Shampoo', line: 'plex', type: 'shampoo', size: '500ml', price: 13900, variantId: 46952616689813, image: 'https://cdn.shopify.com/s/files/1/0763/6025/3589/files/2258.jpg?v=1770900840', url: '/products/kallos-shampoo-plex-bond-builder-500-y-1000ml' },
    plex_noyellow_shampoo: { id: 'K2021', name: 'Plex No Yellow Shampoo', line: 'plex_noyellow', type: 'shampoo', size: '500ml', price: 13900, variantId: 46952609874069, image: 'https://cdn.shopify.com/s/files/1/0763/6025/3589/files/2526.jpg?v=1768684193', url: '/products/kallos-shampoo-plex-bond-builder-no-yellow-500-y-1000ml' },
    vegan_vol_shampoo:   { id: 'VEGAN1679', name: 'Vegan Soul Volumizing Shampoo', line: 'vegan_vol', type: 'shampoo', size: '1000ml', price: 13900, variantId: 46855457177749, image: 'https://cdn.shopify.com/s/files/1/0763/6025/3589/files/914.jpg?v=1770901869', url: '/products/vegan-soul-shampooo-para-cabello-fino-1000ml' },
    vegan_nour_shampoo:  { id: 'VEGAN1684', name: 'Vegan Soul Nourishing Shampoo', line: 'vegan_nour', type: 'shampoo', size: '1000ml', price: 13900, variantId: 46855457112213, image: 'https://cdn.shopify.com/s/files/1/0763/6025/3589/files/726.jpg?v=1768684021', url: '/products/shampoo-vegan-soul-para-cabellos-y-cuero-cabelludo-secos-y-agotados-1000ml' },
    botaniq_sea_shampoo: { id: 'BOT1441', name: 'Botaniq Deep Sea Shampoo', line: 'botaniq_sea', type: 'shampoo', size: '300ml', price: 9900, variantId: 46855468023957, image: 'https://cdn.shopify.com/s/files/1/0763/6025/3589/files/1194.jpg?v=1768684261', url: '/products/kallos-shampoo-botaniq-deep-sea-300ml-hidratacion-y-limpieza-profunda' },
    botaniq_super_shampoo: { id: 'BOT1507', name: 'Botaniq Superfruits Shampoo', line: 'botaniq_super', type: 'shampoo', size: '300ml', price: 9900, variantId: 46855468089493, image: 'https://cdn.shopify.com/s/files/1/0763/6025/3589/files/1192.jpg?v=1768684263', url: '/products/kallos-shampoo-botaniq-superfruits-300ml-nutricion-y-vitalidad-antioxidante' },
    lab35_curl_shampoo:  { id: 'LAB1584', name: 'LAB35 Curl Mania Shampoo', line: 'lab35_curl', type: 'shampoo', size: '300ml', price: 12900, variantId: 46855468777621, image: 'https://cdn.shopify.com/s/files/1/0763/6025/3589/files/924.jpg?v=1768684277', url: '/products/lab35-curl-mania-shampoo-para-cabello-rizado-y-ondulado-300ml' },

    // === MASKS ===
    color_mask:       { id: 'KJMN0813', name: 'Color Hair Mask con Aceite de Linaza y Filtro UV', line: 'color', type: 'mask', size: '1000ml', price: 13900, variantId: 46950755467413, image: 'https://cdn.shopify.com/s/files/1/0763/6025/3589/files/137.jpg?v=1768684259', url: '/products/kallos-mascara-color-275ml-1000ml' },
    algae_mask:       { id: 'KJMN1109', name: 'Algae Hair Mask con Extracto de Algas y Aceite de Oliva', line: 'algae', type: 'mask', size: '1000ml', price: 13900, variantId: 46950773555349, image: 'https://cdn.shopify.com/s/files/1/0763/6025/3589/files/130.jpg?v=1768684256', url: '/products/mascara-kallos-algae-hidratacion-y-minerales-marinos-275-1000ml' },
    banana_mask:      { id: 'KJMN1110', name: 'Banana Hair Mask con Complejo Multivitamínico', line: 'banana', type: 'mask', size: '1000ml', price: 13900, variantId: 46950745702549, image: 'https://cdn.shopify.com/s/files/1/0763/6025/3589/files/667.jpg?v=1770851756', url: '/products/kallos-mascara-banana-275ml-1000ml' },
    coconut_mask:     { id: 'KJMN1611', name: 'Coconut Nutritive Hair Strengthening Mask', line: 'coconut', type: 'mask', size: '1000ml', price: 13900, variantId: 46950745473173, image: 'https://cdn.shopify.com/s/files/1/0763/6025/3589/files/669.jpg?v=1770851864', url: '/products/kallos-mascara-capilar-coconut-hidratacion-profunda-y-brillo-anti-frizz-275ml-1000ml' },
    biotin_mask:      { id: 'KJMN1409', name: 'Biotin Beautifying Hair Mask', line: 'biotin', type: 'mask', size: '1000ml', price: 13900, variantId: 46950743113877, image: 'https://cdn.shopify.com/s/files/1/0763/6025/3589/files/671.jpg?v=1770851838', url: '/products/kallos-mascara-biotin-275ml-1000ml' },
    blueberry_mask:   { id: 'KJMN1151', name: 'Blueberry Revitalizing Hair Mask', line: 'blueberry', type: 'mask', size: '1000ml', price: 13900, variantId: 46950772637845, image: 'https://cdn.shopify.com/s/files/1/0763/6025/3589/files/131.jpg?v=1768684257', url: '/products/kallos-mascara-blueberry-275ml-1000ml' },
    multivitamin_mask:{ id: 'KJMN1206', name: 'Multivitamin Hair Mask', line: 'multivitamin', type: 'mask', size: '1000ml', price: 13900, variantId: 46950752780437, image: 'https://cdn.shopify.com/s/files/1/0763/6025/3589/files/142.jpg?v=1768684261', url: '/products/mascara-kallos-multivitamin-nutricion-y-vitalidad-total-275-1000ml' },
    caviar_mask:      { id: 'KJMN1222', name: 'Caviar Restorative Hair Mask', line: 'caviar', type: 'mask', size: '1000ml', price: 13900, variantId: 46950757597333, image: 'https://cdn.shopify.com/s/files/1/0763/6025/3589/files/133.jpg?v=1768684258', url: '/products/kallos-mascara-caviar-275ml-1000ml' },
    cherry_mask:      { id: 'KJMN1153', name: 'Cherry Conditioning Hair Mask', line: 'cherry', type: 'mask', size: '1000ml', price: 4900, variantId: 46950755991701, image: 'https://cdn.shopify.com/s/files/1/0763/6025/3589/files/135.jpg?v=1768684259', url: '/products/mascara-kallos-cherry-suavidad-y-brillo-intenso-275-1000ml' },
    keratin_mask:     { id: 'KJMN0814', name: 'Keratin Hair Mask con Keratina y Proteína de Leche', line: 'keratin', type: 'mask', size: '1000ml', price: 13900, variantId: 46950754189461, image: 'https://cdn.shopify.com/s/files/1/0763/6025/3589/files/140.jpg?v=1768684260', url: '/products/mascara-kallos-keratin-reconstruccion-profunda-para-cabello-danado-275-1000ml' },
    mango_mask:       { id: 'KJMN1523', name: 'Mango Moisture Repair Hair Mask', line: 'mango', type: 'mask', size: '1000ml', price: 13900, variantId: 46950733185173, image: 'https://cdn.shopify.com/s/files/1/0763/6025/3589/files/1179.jpg?v=1768684304', url: '/products/kallos-mascara-mango-1000ml-hidratacion-profunda-con-extracto-tropical' },
    aloe_mask:        { id: 'KJMN1168', name: 'Aloe Moisture Repair Shine Hair Mask', line: 'aloe', type: 'mask', size: '1000ml', price: 13900, variantId: 46950748455061, image: 'https://cdn.shopify.com/s/files/1/0763/6025/3589/files/665.jpg?v=1768684266', url: '/products/kallos-mascara-capilar-con-aloe-vera-hidratacion-intensiva-calmante-275ml-1000ml' },
    argan_mask:       { id: 'KJMN1870', name: 'Argán Hair Mask', line: 'argan', type: 'mask', size: '1000ml', price: 13900, variantId: 46952615837845, image: 'https://cdn.shopify.com/s/files/1/0763/6025/3589/files/2528.jpg?v=1770900339', url: '/products/kallos-mascara-argan-1000ml' },
    rosemary_mask:    { id: 'KJMN2224', name: 'Rosemary Hair Mask', line: 'rosemary', type: 'mask', size: '1000ml', price: 13900, variantId: 46952608104597, image: 'https://cdn.shopify.com/s/files/1/0763/6025/3589/files/2609.jpg?v=1768684215', url: '/products/kallos-mascara-de-romero-tratamiento-para-fortalecer-y-estimular-el-crecimiento-capilar-275ml-1000ml' },
    silver_mask:      { id: 'K1664', name: 'Silver Reflex Coloring Hair Mask', line: 'silver', type: 'mask', size: '1000ml', price: 16900, variantId: 46950740459669, image: 'https://cdn.shopify.com/s/files/1/0763/6025/3589/files/675.jpg?v=1770851815', url: '/products/kallos-mascara-silver-matizador-para-cabellos-rubios-y-canos-275ml-1000ml' },
    protox_mask:      { id: 'KJMN1150', name: 'Hair Pro-Tox Hair Mask con Keratina, Colágeno y Ác. Hialurónico', line: 'protox', type: 'mask', size: '500ml', price: 14900, variantId: 46952937095317, image: 'https://cdn.shopify.com/s/files/1/0763/6025/3589/files/2251.jpg?v=1768684062', url: '/products/kallos-pro-tox-mascara-275ml-500-y1000ml' },
    protox_super_mask:{ id: 'SUP1776', name: 'Pro-Tox Superfruits Hair Mask', line: 'protox_super', type: 'mask', size: '500ml', price: 12900, variantId: 46950728761493, image: 'https://cdn.shopify.com/s/files/1/0763/6025/3589/files/Disenosintitulo-2026-02-24T173450.801.png?v=1771965544', url: '/products/kallos-mascara-hair-pro-tox-superfruits-tratamiento-intensivo-reparador-y-antioxidante-275ml-500ml-y-1000ml' },
    plex_mask:        { id: 'K1823', name: 'Plex Bond Builder Hair Mask', line: 'plex', type: 'mask', size: '500ml', price: 13900, variantId: 46950734135445, image: 'https://cdn.shopify.com/s/files/1/0763/6025/3589/files/2246.jpg?v=1770851786', url: '/products/kallos-mascara-plex-bond-builder-275ml-500ml-y-1000ml' },
    plex_noyellow_mask: { id: 'K2025', name: 'Plex No Yellow Hair Mask', line: 'plex_noyellow', type: 'mask', size: '500ml', price: 13900, variantId: 46952614887573, image: 'https://cdn.shopify.com/s/files/1/0763/6025/3589/files/2549.jpg?v=1768684192', url: '/products/kallos-mascara-plex-bond-builder-no-yellow-275ml-500ml-y-1000ml' },
    vegan_vol_mask:   { id: 'VEGAN1681', name: 'Vegan Soul Volumizing Hair Mask', line: 'vegan_vol', type: 'mask', size: '1000ml', price: 16900, variantId: 46855457210517, image: 'https://cdn.shopify.com/s/files/1/0763/6025/3589/files/910.jpg?v=1770901750', url: '/products/vegan-soul-mascara-para-cabello-fino-1000ml' },
    vegan_nour_mask:  { id: 'VEGAN1690', name: 'Vegan Soul Nourishing Hair Mask', line: 'vegan_nour', type: 'mask', size: '1000ml', price: 16900, variantId: 46855457144981, image: 'https://cdn.shopify.com/s/files/1/0763/6025/3589/files/909.jpg?v=1770902030', url: '/products/vegan-soul-mascara-para-cabellos-y-cuero-cabelludo-secos-y-agotados-1000ml' },
    botaniq_super_conditioner: { id: 'BOT1548', name: 'Botaniq Superfruits Conditioner', line: 'botaniq_super', type: 'mask', size: '300ml', price: 9900, variantId: 46855469891733, image: 'https://cdn.shopify.com/s/files/1/0763/6025/3589/files/Disenosintitulo-2026-02-25T162021.285.png?v=1772047237', url: '/products/kallos-acondicionador-botaniq-superfruits-300ml-nutricion-natural' },
    lab35_curl_conditioner: { id: 'LAB1585', name: 'LAB35 Curl Mania Conditioner', line: 'lab35_curl', type: 'mask', size: '250ml', price: 13900, variantId: 46855468744853, image: 'https://cdn.shopify.com/s/files/1/0763/6025/3589/files/929.jpg?v=1768684277', url: '/products/kallos-lab35-acondicionador-curl-mania-250ml-definicion-de-ondas' },

    // === STYLING & TREATMENTS ===
    flat_iron_spray:      { id: 'KJMN0356', name: 'Flat Iron Spray — Protección Térmica para Plancha', line: 'styling', type: 'styling', size: '200ml', price: 10900, variantId: 46855468548245, image: 'https://cdn.shopify.com/s/files/1/0763/6025/3589/files/712.jpg?v=1768684273', url: '/products/kallos-protector-termico-flat-iron-spray-200ml-protector-de-calor' },
    straightener_spray:   { id: 'KJMN0797', name: 'Hair Straightener Spray — Alisado con Protección', line: 'styling', type: 'styling', size: '200ml', price: 10900, variantId: 46855468581013, image: 'https://cdn.shopify.com/s/files/1/0763/6025/3589/files/713.jpg?v=1768684273', url: '/products/kallos-protector-termico-para-plancha-200ml-liso-duradero-y-anti-humedad' },
    volumizing_spray:     { id: 'KJMN0795', name: 'Volumizing Spray — Volumen desde la Raíz', line: 'styling', type: 'styling', size: '200ml', price: 10900, variantId: 46855468613781, image: 'https://cdn.shopify.com/s/files/1/0763/6025/3589/files/714.jpg?v=1768684274', url: '/products/kallos-voluminizador-sin-fijacion-200ml-cuerpo-movimiento-y-volumen-natural' },
    keratin_milk:         { id: 'KJMN1228', name: 'Absolute Keratin Milk — Nutrición Sin Enjuague', line: 'styling', type: 'treatment', size: '50ml', price: 9900, variantId: 46855469105301, image: 'https://cdn.shopify.com/s/files/1/0763/6025/3589/files/Keratin.png?v=1770768911', url: '/products/kallos-tratamiento-sin-enjuague-de-keratina-50ml-reparacion-brillo-y-control-frizz' },
    dry_ends_serum:       { id: 'KJMN0414', name: 'Dry Ends Serum — Reparación de Puntas', line: 'styling', type: 'treatment', size: '30ml', price: 6900, variantId: 46855468646549, image: 'https://cdn.shopify.com/s/files/1/0763/6025/3589/files/913.jpg?v=1768684275', url: '/products/kallos-dry-end-serum-30ml-sellador-y-reparador-de-puntas' },
    rosemary_serum:       { id: 'KJMN2230', name: 'Rosemary Dry Ends Serum — Puntas + Crecimiento', line: 'rosemary', type: 'treatment', size: '50ml', price: 12900, variantId: 46855466090645, image: 'https://cdn.shopify.com/s/files/1/0763/6025/3589/files/2604.jpg?v=1768684216', url: '/products/serum-kallos-romero-serum-restaurador-de-brillo-y-suavidad-50ml' },
    protox_14in1:         { id: 'KJMN1243', name: '14 in 1 Keratin Hair Treatment Spray', line: 'protox', type: 'treatment', size: '200ml', price: 15900, variantId: 46855469957269, image: 'https://cdn.shopify.com/s/files/1/0763/6025/3589/files/14_en_1_Keratina.png?v=1770768524', url: '/products/kallos-tratamiento-de-keratina-14-en-1-spray-multi-beneficios-sin-aclarado-200ml' },
    protox_bestin1:       { id: 'KJMN1245', name: 'Pro-Tox Best in 1 Liquid Hair Conditioner', line: 'protox', type: 'treatment', size: '200ml', price: 15900, variantId: 46855468449941, image: 'https://cdn.shopify.com/s/files/1/0763/6025/3589/files/678.jpg?v=1768684271', url: '/products/kallos-hair-bomb-pro-tox-200ml-tratamiento-brillo-extremo' },
    protox_super_bestin1: { id: 'SUP1780', name: 'Pro-Tox Superfruits Hair Bomb — Tratamiento Concentrado', line: 'protox_super', type: 'treatment', size: '200ml', price: 15900, variantId: 46855470088341, image: 'https://cdn.shopify.com/s/files/1/0763/6025/3589/files/Disenosintitulo-2026-02-24T172610.418.png?v=1771964787', url: '/products/kallos-hair-pro-tox-superfruits-hair-bomb-200ml-tratamiento-concentrado' },
    plex_bomb:            { id: 'K1825', name: 'Plex Hair Bomb — Acondicionador Líquido Sin Enjuague', line: 'plex', type: 'treatment', size: '200ml', price: 15900, variantId: 46855464714389, image: 'https://cdn.shopify.com/s/files/1/0763/6025/3589/files/2323.jpg?v=1768684186', url: '/products/kallos-plex-hair-bomb-200ml' },
    plex_serum:           { id: 'K1850', name: 'Plex Serum — Reparación de Puntas', line: 'plex', type: 'treatment', size: '50ml', price: 12900, variantId: 46855464779925, image: 'https://cdn.shopify.com/s/files/1/0763/6025/3589/files/2324.jpg?v=1768684187', url: '/products/kallos-plex-hair-serum-50ml' },
    plex_flat_iron:       { id: 'K1842', name: 'Plex Flat Iron Spray — Protección Térmica Bond Builder', line: 'plex', type: 'styling', size: '200ml', price: 12900, variantId: 46955323392149, image: 'https://cdn.shopify.com/s/files/1/0763/6025/3589/files/Disenosintitulo_74.png?v=1770989104', url: '/products/kallos-linea-plex-protector-termico-capilar-flat-iron-200ml' },
    plex_shine_water:     { id: 'K1826', name: 'Plex Shine Water — Brillo en 9 Segundos', line: 'plex', type: 'treatment', size: '200ml', price: 16900, variantId: 46964810252437, image: 'https://cdn.shopify.com/s/files/1/0763/6025/3589/files/Disenosintitulo_84.png?v=1771340274', url: '/products/kallos-plex-agua-lamelar-200ml-tratamiento-capilar-reparador' },
    botaniq_spray:        { id: 'BOT1545', name: 'Botaniq Superfruits Hair Renewing Spray', line: 'botaniq_super', type: 'treatment', size: '150ml', price: 7900, variantId: 46855468122261, image: 'https://cdn.shopify.com/s/files/1/0763/6025/3589/files/1191.jpg?v=1768684264', url: '/products/kallos-spray-botaniq-superfruits-150ml-brillo-antioxidante' },
    lab35_curl_spray:     { id: 'LAB1586', name: 'LAB35 Curl Mania Spray', line: 'lab35_curl', type: 'styling', size: '150ml', price: 13900, variantId: 46855468843157, image: 'https://cdn.shopify.com/s/files/1/0763/6025/3589/files/923.jpg?v=1768684278', url: '/products/kallos-lab35-spray-para-rizos-curl-mania-150ml-definicion-y-fijacion' },
  };


  /* ------------------------------------------
     QUIZ QUESTIONS
  ------------------------------------------ */

  const QUESTIONS = [
    {
      id: 'color_status',
      number: 1,
      title: '¿Tu cabello está teñido o decolorado?',
      options: [
        { value: 'natural',   icon: '✨', label: 'No, es natural',                       desc: 'Sin tratamientos químicos de color' },
        { value: 'dark_dye',  icon: '🎨', label: 'Sí, teñido oscuro',                    desc: 'Castaño, negro, rojo, cobrizo' },
        { value: 'blonde',    icon: '💛', label: 'Sí, rubio o con mechas',                desc: 'Mechas, balayage, rubio teñido' },
        { value: 'bleached',  icon: '⚡', label: 'Sí, decolorado o platinado',            desc: 'Decoloración total o parcial' },
      ]
    },
    {
      id: 'hair_type',
      number: 2,
      title: '¿Cómo es tu tipo de cabello?',
      options: [
        { value: 'fine',    icon: '🪶', label: 'Fino y sin volumen',               desc: 'Se aplasta fácilmente, poco cuerpo' },
        { value: 'normal',  icon: '💁‍♀️', label: 'Normal',                            desc: 'Ni muy fino ni muy grueso' },
        { value: 'thick',   icon: '🦁', label: 'Grueso y abundante',                desc: 'Mucho cabello, difícil de manejar' },
        { value: 'curly',   icon: '🌀', label: 'Rizado u ondulado',                 desc: 'Rizos definidos u ondas naturales' },
      ]
    },
    {
      id: 'concern',
      number: 3,
      title: '¿Cuál es tu mayor preocupación capilar?',
      options: [
        { value: 'hair_loss', icon: '😟', label: 'Caída o adelgazamiento',          desc: 'Se me cae mucho o está cada vez más fino' },
        { value: 'dryness',   icon: '🏜️', label: 'Sequedad y deshidratación',       desc: 'Seco, áspero, sin humedad' },
        { value: 'frizz',     icon: '💨', label: 'Frizz y puntas abiertas',          desc: 'Encrespamiento, puntas dañadas' },
        { value: 'dullness',  icon: '😶', label: 'Opaco, sin vida ni brillo',        desc: 'Apagado, sin luminosidad' },
        { value: 'damage',    icon: '🔥', label: 'Muy dañado',                       desc: 'Por químicos, calor o tratamientos' },
        { value: 'oily',      icon: '💧', label: 'Graso, se ensucia rápido',         desc: 'Exceso de grasa en raíz y cuero cabelludo' },
      ]
    },
    {
      id: 'heat_usage',
      number: 4,
      title: '¿Usas herramientas de calor habitualmente?',
      options: [
        { value: 'flat_iron', icon: '🔌', label: 'Sí, plancha',                     desc: 'Uso plancha frecuentemente' },
        { value: 'blow_dryer',icon: '💨', label: 'Sí, secador',                     desc: 'Uso secador frecuentemente' },
        { value: 'both',      icon: '🔥', label: 'Sí, ambos',                       desc: 'Plancha + secador regularmente' },
        { value: 'none',      icon: '🌿', label: 'No, casi nunca',                  desc: 'Prefiero secado natural' },
      ]
    },
    {
      id: 'preference',
      number: 5,
      title: '¿Qué valoras más en tus productos capilares?',
      options: [
        { value: 'vegan',       icon: '🌱', label: 'Veganos y naturales',            desc: 'Fórmulas sin ingredientes animales' },
        { value: 'professional',icon: '💎', label: 'Reparación profesional',         desc: 'Tratamientos intensivos de salón' },
        { value: 'fast_results',icon: '⚡', label: 'Resultados rápidos',             desc: 'Mejoras visibles desde el primer uso' },
        { value: 'no_pref',     icon: '👍', label: 'Sin preferencia especial',       desc: 'Lo que mejor funcione para mi cabello' },
      ]
    },
  ];


  /* ------------------------------------------
     PACK DEFINITIONS
  ------------------------------------------ */

  const PACK_INFO = {
    color:         { name: 'Pack Protección Color',       desc: 'Protege la vibración de tu color con aceite de linaza y filtro UV. Tu tinte durará más tiempo, con brillo y sedosidad.' },
    argan:         { name: 'Pack Rubias Radiantes',        desc: 'Argán + matización: protege tu rubio o mechas del lavado, sella las puntas y aporta un brillo deslumbrante.' },
    plex_noyellow: { name: 'Pack Platinada Perfecta',      desc: 'Neutraliza los tonos amarillos mientras repara los enlaces rotos por la decoloración. Color frío y cabello fuerte.' },
    plex:          { name: 'Pack Rescate Total',            desc: 'Tecnología PLEX que reconstruye los enlaces moleculares de tu cabello. Reparación profunda para cabello procesado químicamente.' },
    rosemary:      { name: 'Pack Anti-Caída Romero',        desc: 'El romero estimula la circulación del cuero cabelludo y fortalece desde la raíz. 7 aceites naturales nutren cada hebra.' },
    biotin:        { name: 'Pack Volumen & Densidad',       desc: 'La biotina activa el metabolismo folicular, engrosa tu cabello y le da el volumen que necesita.' },
    aloe:          { name: 'Pack Hidratación & Brillo',     desc: 'El aloe vera hidrata en profundidad, estimula el crecimiento y deja tu cabello con un brillo luminoso.' },
    algae:         { name: 'Pack Hidratación Profunda',     desc: '5 tipos de algas marinas reestructuran la fibra capilar. Restaura la elasticidad y flexibilidad de tu cabello.' },
    mango:         { name: 'Pack Hidratación Tropical',     desc: 'El mango crea un escudo protector que sella la humedad. Aminoácidos esenciales y antioxidantes para tu cabello rizado.' },
    keratin:       { name: 'Pack Anti-Frizz Keratina',      desc: 'La keratina reconstruye la estructura dañada del cabello, elimina el frizz y sella las puntas abiertas.' },
    multivitamin:  { name: 'Pack Energía & Vitalidad',      desc: 'Ginseng + cítricos + vitaminas energizan tu cabello, devuelven su brillo natural y estimulan el crecimiento.' },
    caviar:        { name: 'Pack Restauración Premium',      desc: 'El caviar aporta proteínas, lípidos y minerales de alta concentración. Restauración intensiva para devolver la juventud a tu cabello.' },
    protox:        { name: 'Pack Pro-Tox Reparación Triple', desc: 'Keratina + Colágeno + Ácido Hialurónico: reconstruye la estructura, mejora la elasticidad e hidrata en profundidad.' },
    deep_cleansing:{ name: 'Pack Detox & Equilibrio',        desc: 'Limpieza profunda con cola de caballo y ortiga. Regula la grasa y reequilibra tu cuero cabelludo.' },
    vegan_vol:     { name: 'Pack Vegano Volumen',            desc: 'Fórmula 100% vegana con bambú y coco que da volumen sin pesar. Para un cabello lleno de vida y movimiento.' },
    vegan_nour:    { name: 'Pack Vegano Nutrición',          desc: 'Nutrición profunda 100% vegana con proteína vegetal y aguacate. Hidrata y repara sin ingredientes de origen animal.' },
    botaniq:       { name: 'Pack Botánico Natural',          desc: 'Fórmulas veganas con superfrutas antioxidantes que fortalecen y renuevan tu cabello de forma natural.' },
    lab35_curl:    { name: 'Pack Rizos Definidos',           desc: 'Keratina y extracto de bambú definen tus rizos, eliminan el frizz y dejan tus ondas con movimiento natural.' },
    coconut:       { name: 'Pack Fortalecimiento Coco',      desc: 'El aceite de coco penetra la fibra capilar previniendo la pérdida de proteína. Fortalece y reduce la rotura.' },
    blueberry:     { name: 'Pack Revitalización Antioxidante', desc: 'Arándano + aguacate revitalizan el cabello tratado químicamente. Antioxidantes que protegen contra el daño ambiental.' },
  };


  /* ------------------------------------------
     RECOMMENDATION ENGINE
  ------------------------------------------ */

  function getRecommendation(answers) {
    const { color_status, hair_type, concern, heat_usage, preference } = answers;

    let shampooKey, maskKey, thirdKey;
    let packLine;

    // ===== PASO 1: Determinar línea (shampoo + mask) =====

    // Prioridad 1: Estado del color
    if (color_status === 'bleached') {
      packLine = 'plex_noyellow';
      shampooKey = 'plex_noyellow_shampoo';
      maskKey = 'plex_noyellow_mask';
    }
    else if (color_status === 'blonde') {
      packLine = 'argan';
      shampooKey = 'argan_shampoo';
      maskKey = 'argan_mask';
    }
    else if (color_status === 'dark_dye') {
      packLine = 'color';
      shampooKey = 'color_shampoo';
      maskKey = 'color_mask';
    }
    else {
      // Cabello natural: decidir por preocupación

      // Override vegano
      if (preference === 'vegan') {
        if (hair_type === 'fine' || concern === 'hair_loss') {
          packLine = 'vegan_vol';
          shampooKey = 'vegan_vol_shampoo';
          maskKey = 'vegan_vol_mask';
        } else if (concern === 'dryness' || concern === 'damage') {
          packLine = 'vegan_nour';
          shampooKey = 'vegan_nour_shampoo';
          maskKey = 'vegan_nour_mask';
        } else {
          packLine = 'botaniq';
          shampooKey = 'botaniq_super_shampoo';
          maskKey = 'botaniq_super_conditioner';
        }
      }
      else {
        switch (concern) {
          case 'hair_loss':
            packLine = 'rosemary';
            shampooKey = 'rosemary_shampoo';
            maskKey = 'rosemary_mask';
            break;

          case 'dryness':
            if (hair_type === 'fine') {
              packLine = 'aloe';
              shampooKey = 'aloe_shampoo';
              maskKey = 'aloe_mask';
            } else if (hair_type === 'curly') {
              packLine = 'mango';
              shampooKey = 'mango_shampoo';
              maskKey = 'mango_mask';
            } else {
              packLine = 'algae';
              shampooKey = 'algae_shampoo';
              maskKey = 'algae_mask';
            }
            break;

          case 'frizz':
            packLine = 'keratin';
            shampooKey = 'keratin_shampoo';
            maskKey = 'keratin_mask';
            break;

          case 'dullness':
            packLine = 'multivitamin';
            shampooKey = 'multivitamin_shampoo';
            maskKey = 'multivitamin_mask';
            break;

          case 'damage':
            if (preference === 'professional') {
              packLine = 'protox';
              shampooKey = 'protox_shampoo';
              maskKey = 'protox_mask';
            } else {
              packLine = 'caviar';
              shampooKey = 'caviar_shampoo';
              maskKey = 'caviar_mask';
            }
            break;

          case 'oily':
            packLine = 'deep_cleansing';
            shampooKey = 'deep_cleansing_shampoo';
            maskKey = 'cherry_mask';
            break;

          default:
            // Fallback por tipo de cabello
            if (hair_type === 'fine') {
              packLine = 'biotin';
              shampooKey = 'biotin_shampoo';
              maskKey = 'biotin_mask';
            } else if (hair_type === 'curly') {
              packLine = 'coconut';
              shampooKey = 'coconut_shampoo';
              maskKey = 'coconut_mask';
            } else {
              packLine = 'multivitamin';
              shampooKey = 'multivitamin_shampoo';
              maskKey = 'multivitamin_mask';
            }
        }
      }
    }

    // ===== PASO 2: Determinar 3er producto =====

    // Cabello rizado + no calor → Curl Power / LAB35 Curl Mania
    if (hair_type === 'curly' && heat_usage === 'none') {
      thirdKey = 'lab35_curl_spray';
    }
    else if (heat_usage === 'flat_iron') {
      thirdKey = (packLine === 'plex' || packLine === 'plex_noyellow') ? 'plex_flat_iron' : 'flat_iron_spray';
    }
    else if (heat_usage === 'blow_dryer') {
      thirdKey = hair_type === 'fine' ? 'volumizing_spray' : 'straightener_spray';
    }
    else if (heat_usage === 'both') {
      thirdKey = 'protox_14in1';
    }
    else {
      // No usa calor
      if (concern === 'frizz') {
        thirdKey = 'dry_ends_serum';
      } else if (packLine === 'rosemary') {
        thirdKey = 'rosemary_serum';
      } else if (packLine === 'plex' || packLine === 'plex_noyellow') {
        thirdKey = 'plex_serum';
      } else if (packLine === 'protox') {
        thirdKey = 'protox_bestin1';
      } else if (packLine === 'protox_super') {
        thirdKey = 'protox_super_bestin1';
      } else if (packLine === 'botaniq') {
        thirdKey = 'botaniq_spray';
      } else if (hair_type === 'fine') {
        thirdKey = 'volumizing_spray';
      } else {
        thirdKey = 'keratin_milk';
      }
    }

    // Special case: rubias → agregar Silver shampoo como 3er (matizante)
    if (color_status === 'blonde') {
      thirdKey = 'silver_shampoo';
    }

    const shampoo = PRODUCTS[shampooKey];
    const mask = PRODUCTS[maskKey];
    const third = PRODUCTS[thirdKey];
    const info = PACK_INFO[packLine] || PACK_INFO.multivitamin;

    return {
      packName: info.name,
      packDesc: info.desc,
      products: [
        { ...shampoo, step: 'Paso 1', typeLabel: 'Shampoo' },
        { ...mask, step: 'Paso 2', typeLabel: 'Máscara' },
        { ...third, step: 'Paso 3', typeLabel: third.type === 'styling' ? 'Styling' : 'Tratamiento' },
      ],
      totalPrice: (shampoo?.price || 0) + (mask?.price || 0) + (third?.price || 0),
    };
  }


  /* ------------------------------------------
     QUIZ UI CONTROLLER
  ------------------------------------------ */

  class KallosQuiz {
    constructor(container) {
      this.container = container;
      this.currentScreen = 0; // 0 = welcome, 1-5 = questions, 6 = loading, 7 = result
      this.answers = {};
      this.totalQuestions = QUESTIONS.length;
      this.init();
    }

    init() {
      this.render();
      this.showScreen(0);
    }

    render() {
      this.container.innerHTML = '';
      this.container.className = 'quiz-container';

      // Progress bar
      const progressHTML = `
        <div class="quiz-progress-wrapper" style="display:none;">
          <div class="quiz-progress__text">Pregunta <span class="quiz-progress__current">1</span> de ${this.totalQuestions}</div>
          <div class="quiz-progress">
            <div class="quiz-progress__bar"></div>
          </div>
        </div>
      `;

      // Welcome screen
      const welcomeHTML = `
        <div class="quiz-screen" data-screen="0">
          <div class="quiz-welcome">
            <div class="quiz-welcome__badge">Test Capilar</div>
            <h1 class="quiz-welcome__title">Descubre tu<br>Pack Ideal Kallos</h1>
            <p class="quiz-welcome__subtitle">Responde 5 preguntas simples y encontraremos la rutina perfecta para tu cabello.</p>
            <div class="quiz-welcome__features">
              <div class="quiz-welcome__feature">
                <svg class="quiz-welcome__feature-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"/><path d="M12 6v6l4 2"/></svg>
                <span>45 segundos</span>
              </div>
              <div class="quiz-welcome__feature">
                <svg class="quiz-welcome__feature-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M9 12l2 2 4-4"/><circle cx="12" cy="12" r="10"/></svg>
                <span>5 preguntas</span>
              </div>
              <div class="quiz-welcome__feature">
                <svg class="quiz-welcome__feature-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4"/></svg>
                <span>Pack de 3 productos</span>
              </div>
            </div>
            <button class="quiz-btn quiz-btn--gold" data-action="start">
              Comenzar
              <span class="quiz-btn__arrow quiz-btn__arrow--right">&rarr;</span>
            </button>
          </div>
        </div>
      `;

      // Question screens
      let questionsHTML = '';
      QUESTIONS.forEach((q, index) => {
        const optionsHTML = q.options.map(opt => `
          <div class="quiz-option" data-question="${q.id}" data-value="${opt.value}">
            <span class="quiz-option__icon">${opt.icon}</span>
            <div>
              <div class="quiz-option__label">${opt.label}</div>
              <div class="quiz-option__desc">${opt.desc}</div>
            </div>
          </div>
        `).join('');

        const colClass = q.options.length > 4 ? '' : '';

        questionsHTML += `
          <div class="quiz-screen" data-screen="${index + 1}">
            <div class="quiz-question__number">Pregunta ${q.number}</div>
            <h2 class="quiz-question__title">${q.title}</h2>
            <div class="quiz-options ${colClass}">
              ${optionsHTML}
            </div>
            <div class="quiz-nav">
              <button class="quiz-btn quiz-btn--back" data-action="back">
                <span class="quiz-btn__arrow quiz-btn__arrow--left">&larr;</span>
                Volver
              </button>
              <button class="quiz-btn quiz-btn--primary" data-action="next" disabled>
                ${index === QUESTIONS.length - 1 ? 'Ver mi resultado' : 'Siguiente'}
                <span class="quiz-btn__arrow quiz-btn__arrow--right">&rarr;</span>
              </button>
            </div>
          </div>
        `;
      });

      // Loading screen
      const loadingHTML = `
        <div class="quiz-screen" data-screen="${this.totalQuestions + 1}">
          <div class="quiz-loading">
            <div class="quiz-loading__spinner"></div>
            <p class="quiz-loading__text">Analizando tu cabello...</p>
          </div>
        </div>
      `;

      // Result screen (populated dynamically)
      const resultHTML = `
        <div class="quiz-screen" data-screen="${this.totalQuestions + 2}">
          <div class="quiz-result" id="quiz-result"></div>
        </div>
      `;

      this.container.innerHTML = progressHTML + welcomeHTML + questionsHTML + loadingHTML + resultHTML;

      // Bind events
      this.bindEvents();
    }

    bindEvents() {
      // Start button
      this.container.querySelector('[data-action="start"]').addEventListener('click', () => {
        this.showScreen(1);
      });

      // Option clicks
      this.container.querySelectorAll('.quiz-option').forEach(opt => {
        opt.addEventListener('click', () => {
          const questionId = opt.dataset.question;
          const value = opt.dataset.value;

          // Deselect siblings
          opt.parentElement.querySelectorAll('.quiz-option').forEach(s => s.classList.remove('selected'));
          opt.classList.add('selected');

          // Store answer
          this.answers[questionId] = value;

          // Enable next button
          const screen = opt.closest('.quiz-screen');
          const nextBtn = screen.querySelector('[data-action="next"]');
          if (nextBtn) nextBtn.disabled = false;

          // Auto-advance after short delay
          setTimeout(() => {
            if (this.currentScreen < this.totalQuestions) {
              this.showScreen(this.currentScreen + 1);
            } else {
              this.showLoading();
            }
          }, 400);
        });
      });

      // Back buttons
      this.container.querySelectorAll('[data-action="back"]').forEach(btn => {
        btn.addEventListener('click', () => {
          if (this.currentScreen > 1) {
            this.showScreen(this.currentScreen - 1);
          } else {
            this.showScreen(0);
          }
        });
      });

      // Next buttons
      this.container.querySelectorAll('[data-action="next"]').forEach(btn => {
        btn.addEventListener('click', () => {
          if (this.currentScreen < this.totalQuestions) {
            this.showScreen(this.currentScreen + 1);
          } else {
            this.showLoading();
          }
        });
      });
    }

    showScreen(index) {
      this.currentScreen = index;

      // Hide all screens
      this.container.querySelectorAll('.quiz-screen').forEach(s => {
        s.classList.remove('active', 'visible');
      });

      // Show target screen
      const target = this.container.querySelector(`[data-screen="${index}"]`);
      if (!target) return;

      target.classList.add('active');
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          target.classList.add('visible');
        });
      });

      // Update progress bar
      const progressWrapper = this.container.querySelector('.quiz-progress-wrapper');
      if (index >= 1 && index <= this.totalQuestions) {
        progressWrapper.style.display = 'block';
        const pct = ((index) / this.totalQuestions) * 100;
        this.container.querySelector('.quiz-progress__bar').style.width = pct + '%';
        this.container.querySelector('.quiz-progress__current').textContent = index;
      } else {
        progressWrapper.style.display = 'none';
      }

      // Restore selection state if going back
      if (index >= 1 && index <= this.totalQuestions) {
        const q = QUESTIONS[index - 1];
        const savedAnswer = this.answers[q.id];
        if (savedAnswer) {
          const opt = target.querySelector(`[data-value="${savedAnswer}"]`);
          if (opt) opt.classList.add('selected');
          const nextBtn = target.querySelector('[data-action="next"]');
          if (nextBtn) nextBtn.disabled = false;
        }
      }

      // Scroll to top
      window.scrollTo({ top: this.container.offsetTop - 100, behavior: 'smooth' });
    }

    showLoading() {
      this.showScreen(this.totalQuestions + 1);

      setTimeout(() => {
        const result = getRecommendation(this.answers);
        this.renderResult(result);
        this.showScreen(this.totalQuestions + 2);
      }, 1800);
    }

    renderResult(result) {
      const resultContainer = document.getElementById('quiz-result');
      const formatter = new Intl.NumberFormat('es-CL', { style: 'currency', currency: 'CLP', minimumFractionDigits: 0 });

      const canAddToCart = result.products.every(p => p.variantId && p.variantId !== 0);

      const productsHTML = result.products.map(p => {
        const imageContent = p.image
          ? `<img class="quiz-product__image" src="${p.image}" alt="${p.name}">`
          : `<div class="quiz-product__image-placeholder">📦</div>`;

        const linkHref = p.url || '#';
        const linkTarget = p.url ? '' : '';
        const linkStyle = p.url ? '' : ' style="pointer-events:none;opacity:0.5"';

        return `
          <div class="quiz-product">
            <a href="${linkHref}" class="quiz-product__image-wrapper"${linkTarget}${linkStyle}>
              ${imageContent}
            </a>
            <div class="quiz-product__info">
              <div class="quiz-product__type">${p.step} — ${p.typeLabel}</div>
              <a href="${linkHref}" class="quiz-product__name"${linkTarget}${linkStyle}>${p.name}</a>
              <div class="quiz-product__size">${p.size}</div>
              <div class="quiz-product__price">${formatter.format(p.price)}</div>
            </div>
          </div>
        `;
      }).join('');

      const cartButtonHTML = canAddToCart
        ? `<button class="quiz-btn quiz-btn--gold" data-action="add-to-cart">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" style="vertical-align:middle;margin-right:6px"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/></svg>
            Agregar Pack al Carrito
          </button>`
        : `<a href="/collections/kallos" class="quiz-btn quiz-btn--gold">Ver Productos Kallos</a>`;

      resultContainer.innerHTML = `
        <div class="quiz-result__badge">Tu resultado</div>
        <h2 class="quiz-result__title">Tu Pack Ideal Kallos</h2>
        <div class="quiz-result__pack-name">${result.packName}</div>
        <div class="quiz-divider"></div>
        <p class="quiz-result__desc">${result.packDesc}</p>

        <div class="quiz-products">
          ${productsHTML}
        </div>

        <div class="quiz-total">
          <div>
            <div class="quiz-total__label">Total del Pack</div>
            <div class="quiz-total__savings">3 productos para tu rutina completa</div>
          </div>
          <div class="quiz-total__price">${formatter.format(result.totalPrice)}</div>
        </div>

        <div class="quiz-result__actions">
          ${cartButtonHTML}
          <button class="quiz-btn quiz-btn--outline" data-action="restart">
            Repetir el test
          </button>
        </div>
        <div class="quiz-cart-feedback" style="display:none"></div>
      `;

      // Bind restart
      resultContainer.querySelector('[data-action="restart"]').addEventListener('click', () => {
        this.answers = {};
        this.render();
        this.showScreen(0);
      });

      // Bind add-to-cart
      const cartBtn = resultContainer.querySelector('[data-action="add-to-cart"]');
      if (cartBtn) {
        cartBtn.addEventListener('click', () => this.addPackToCart(result.products, cartBtn));
      }
    }

    addPackToCart(products, btn) {
      const items = products.filter(p => p.variantId && p.variantId !== 0).map(p => ({ id: p.variantId, quantity: 1 }));
      if (!items.length) return;

      btn.disabled = true;
      btn.textContent = 'Agregando...';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      })
      .then(res => res.json().then(data => ({ ok: res.ok, status: res.status, data })))
      .then(({ ok, status, data }) => {
        if (!ok) {
          throw new Error(data.description || data.message || ('Error ' + status));
        }

        btn.innerHTML = '&#10003; Pack agregado al carrito';
        btn.classList.add('quiz-btn--success');

        // Refresh cart sections then open drawer
        this.openCartDrawer();
      })
      .catch((err) => {
        btn.textContent = 'Error — Intenta de nuevo';
        btn.disabled = false;
        console.error('[Quiz] Add to cart error:', err.message);
      });
    }

    openCartDrawer() {
      // Strategy 1: fetch updated cart sections and dispatch cart:update for Horizon
      const cartItems = document.querySelector('cart-items-component[data-section-id]');
      const sectionId = cartItems ? cartItems.dataset.sectionId : null;

      const sectionsUrl = sectionId
        ? '/cart.js?sections=' + encodeURIComponent(sectionId)
        : '/cart.js';

      fetch(sectionsUrl, { headers: { 'Accept': 'application/json' } })
        .then(r => r.json())
        .then(cartData => {
          // Dispatch Horizon's cart:update event with fresh section HTML
          document.dispatchEvent(new CustomEvent('cart:update', {
            bubbles: true,
            detail: {
              source: 'quiz',
              data: {
                source: 'quiz',
                itemCount: cartData.item_count || 0,
                sections: cartData.sections || {},
              },
            },
          }));

          // Strategy 2: directly open the cart drawer dialog
          setTimeout(() => {
            const cartDrawer = document.querySelector('cart-drawer-component');
            if (cartDrawer) {
              if (typeof cartDrawer.open === 'function') {
                cartDrawer.open();
              } else {
                const dialog = cartDrawer.querySelector('dialog');
                if (dialog && !dialog.open) {
                  dialog.showModal();
                }
              }
            }
          }, 150);
        })
        .catch(() => {
          // If sections fetch fails, still try to open drawer
          const cartDrawer = document.querySelector('cart-drawer-component');
          if (cartDrawer) {
            const dialog = cartDrawer.querySelector('dialog');
            if (dialog && !dialog.open) dialog.showModal();
          }
        });
    }
  }


  /* ------------------------------------------
     INIT
  ------------------------------------------ */

  function initQuiz() {
    const container = document.getElementById('kallos-quiz');
    if (container) {
      new KallosQuiz(container);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initQuiz);
  } else {
    initQuiz();
  }

})();
